/**
 * Test IDs for QA automation.
 */
export const testIds = {
  goodProfileFormCommodityCode: "good-profile-form-commodity-code",
  goodProfileFormLabel: "good-profile-form-label",
  goodProfileFormCommodityClassPicker: "good-profile-form-commodity-class-picker",
  goodProfileFormCommodityClassSearch: "good-profile-form-commodity-class-search",
  goodProfileFormRemoveCondition: "good-profile-form-remove-condition",
  goodProfileFormRemoveEquivalence: "good-profile-form-remove-equivalence",
  goodProfileFormAddEquivalence: "good-profile-form-add-equivalence",
  goodProfileFormRemoveRestriction: "good-profile-form-remove-restriction",
  goodProfileFormAddRestriction: "good-profile-form-add-restriction",
  goodProfileFormAddDocument: "good-profile-form-add-document",
  goodProfileFormOpenDocument: "good-profile-form-open-document",
  goodProfileFormRemoveDocument: "good-profile-form-remove-document",
  goodProfileFormSave: "good-profile-form-save",
} as const;
